import {Box, ButtonBase} from '@mui/material';
import {DateTime} from 'luxon';
import GeoJSON from 'ol/format/GeoJSON';
import {FC} from 'react';
import {Link, useLocation} from 'react-router';
import VisualizationThumbnail from './VisualizationThumbnail.tsx';
import {ANALYZE_VISUALIZE_ROUTE} from '@src/constants/routes.ts';
import {AppLocationState} from '@src/types/appLocation.ts';
import {HighlightMemberWithCollection} from '@src/types/configurations.ts';

export type HighlightProps = {highlight: HighlightMemberWithCollection};

export const Highlight: FC<HighlightProps> = ({highlight}) => {
  const location = useLocation();
  const from = DateTime.fromISO(highlight.fromTime);
  const to = DateTime.fromISO(highlight.toTime);
  const geo = new GeoJSON().readGeometry(highlight.areaOfInterest);
  const extent = geo.getExtent();
  const search = new URLSearchParams(location.search);
  const navigateParams = new URLSearchParams({
    ...Object.fromEntries(search.entries()),
    // TODO: must use serialize to construct the parameters
    collection: highlight.collectionId,
    layer: highlight.layerId,
    from: from.toISO() ?? '',
    to: to.endOf('day').toISO() ?? '',
  }).toString();

  return (
    <ButtonBase
      component={Link}
      key={highlight.id}
      to={{
        pathname: `/${ANALYZE_VISUALIZE_ROUTE}`,
        search: navigateParams,
      }}
      state={{mapExtent: {bbox: extent}} satisfies AppLocationState}
      role="button"
      sx={{
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'flex-start',
        gap: 2,
        paddingInline: 2,
        paddingBlock: 0.75,
        color: 'text.secondary',
        ':hover': {
          backgroundColor: 'action.hover',
        },
      }}
    >
      <VisualizationThumbnail
        highlight={highlight}
        rootProps={{
          sx: {
            display: 'flex',
            justifyContent: 'center',
          },
        }}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexShrink: 1,
          gap: 1,
          justifyContent: 'stretch',
          textAlign: 'left',
        }}
      >
        <Box sx={{color: 'text.primary', fontSize: 14}}>{highlight.title}</Box>
        <Box sx={{fontSize: 13}}>
          {from.toISODate()} | {from.toFormat('HH:mm:ss')} UTC
        </Box>
      </Box>
    </ButtonBase>
  );
};
export default Highlight;
